import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { CompanyDetails } from '../interfaces/company-details.interface'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { environment } from 'src/environments/environment'
import { CustomerDetails } from '../interfaces/customer-details.interface'

@Injectable({
    providedIn: 'root',
})
export class PublicService {
    #httpClient = inject(HttpClient)

    getCompanyDetails(companyId: number): Observable<CompanyDetails> {
        return this.#httpClient
            .get<ApiResponse<CompanyDetails>>(`${environment.baseUrl}public/company/${companyId}`)
            .pipe(map((response) => response.result))
    }

    getCustomerDetails(customerId: string): Observable<CustomerDetails> {
        return this.#httpClient
            .get<ApiResponse<any>>(`${environment.baseUrl}public/customers/${customerId}`)
            .pipe(map((response) => response.result))
    }
}
